import { render, staticRenderFns } from "./TableDynamicUserRole.vue?vue&type=template&id=88a31226&scoped=true&"
import script from "./TableDynamicUserRole.vue?vue&type=script&lang=js&"
export * from "./TableDynamicUserRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a31226",
  null
  
)

export default component.exports